// extracted by mini-css-extract-plugin
export default {"list":"List_list__CaLDn"};